module.exports = __webpack_public_path__ + "img/st.0ed70ad4.svg";